import { Component, OnInit, ViewChild } from '@angular/core';

import { ApiError, AuthService, ConfigService, MessageService, DataTablesService, VisualizacaoStorageService } from '../../../../core';
import { ajustarUrl } from '../../../../core/utils';
import { ConfigEmpresa, createNomeCliente, createNomeRepresentante } from '../../../configuracoes/app/empresa';
import { ClienteInternetSearchTotal } from './cliente-internet-search-total';
import { ClienteInternetSearch } from './cliente-internet-search';
import { ClienteInternetFilter, ClienteInternetFilterCollapseComponent } from './filter';
import { ClienteInternetHttpService } from './services';
import { ClienteInternetFormModalComponent } from './form-modal';

@Component({
    selector: 'sgt-cliente-internet',
    templateUrl: './cliente-internet.component.html',
    styleUrls: ['./cliente-internet.component.less']
})
export class ClienteInternetComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    total: ClienteInternetSearchTotal;
    entities: ClienteInternetSearch[];

    // Filter
    filter = new ClienteInternetFilter();
    @ViewChild('filterCollapse', {static: true}) filterCollapse: ClienteInternetFilterCollapseComponent;
    // Datatable
    dataTable: any;
    // Form Modal
    @ViewChild('formModal') formModal: ClienteInternetFormModalComponent;


    constructor(private authService: AuthService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private clienteInternetHttpService: ClienteInternetHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();
    }

    onFilterInitialized() {
        // Obtendo o filtro armazenado no storage
        const vs = this.visualizacaoStorageService.get();
        if (vs != null) {
            // Se possuir os dados, então setamos o filtro
            vs.filterValues.forEach((value, key) => this.filter[key] = value);
            this.filterCollapse.isFilterDirty = true;
        }

        this.search();
    }

    search() {
        this.filterCollapse.close();
        this.visualizacaoStorageService.set(this.filter, '', null, null);

        // Primeiro obtemos os totais de clientes e suas informações de internet
        this.getTotal()
            .then(() => {
                if (!this.dataTable) { // Table ainda não criada
                    this.createTable();
                } else { // Table já criada, somente damos um reload
                    this.dataTable.draw(false);
                }
            })
            .catch(() => {});
    }

    /** Obtem os totais para a pesquisa das informações de internet dos clientes */
    private getTotal(): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            this.clienteInternetHttpService.getSearchTotal(this.filter)
                .subscribe(
                    entity => {
                        this.total = entity;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar os totais das informações de internet dos clientes', error);
                        reject(error);
                    }
                );
        });
    }

    /** Cria a dataTable com pesquisa dos clientes sob-demanda */
    private createTable() {
        this.dataTablesService.showTable('#tableClienteInternet', this.dataTable, {
            // order: [[1, 'asc']], // nome asc
            ordering: false,
            searching: false,
            info: false,
            serverSide: true,
            processing: true,
            deferRender: true,
            scroller: true, // Habilita a pesquisa sob-demanda através do scroll na table
            // scrollY: 'calc(100vh - 162px)',
            scrollX: true,
            columns: [
                {
                    data: null,
                    className: 'col-options',
                    render: (data: ClienteInternetSearch, type, row, meta) => {
                        let options = '';

                        // Edit
                        options = '<a id="edit" title="Editar"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>';

                        return options;
                    },
                    createdCell: (td, cellData: ClienteInternetSearch, rowData, row, col) => {
                        // Vinculando os eventos de click das opções da tabela
                        const myself = this;
                        jQuery(td).on('click', 'a', function() {
                            if (this.id === 'edit') {
                                myself.openFormModal(cellData);
                            }
                        });
                    }
                },
                {
                    data: 'nome',
                    className: 'col-nome',
                    render: (data, type, row: ClienteInternetSearch, meta) => {
                        if (!row) {
                            return data;
                        }
                        return `${row.codigoIntegracaoErp ? row.codigoIntegracaoErp + ' - ' : ''} ${createNomeCliente(this.configEmpresa.identificacaoCliente, row.nome, row.nomeFantasia)}`;
                    },
                    createdCell: (td, cellData, rowData: ClienteInternetSearch, row, col) => {
                        if (rowData) {
                            td.title = `${rowData.codigoIntegracaoErp ? rowData.codigoIntegracaoErp + ' - ' : ''} ${createNomeCliente(this.configEmpresa.identificacaoCliente, rowData.nome, rowData.nomeFantasia)}`;
                        }
                    }
                },
                {
                    data: 'nomeRepresentante',
                    className: 'col-nome-representante',
                    visible: !this.isRepresentante,
                    render: (data, type, row: ClienteInternetSearch, meta) => {
                        if (!row) {
                            return data;
                        }
                        return createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, (row.nomeRepresentante ? row.nomeRepresentante : ''), (row.nomeFantasiaRepresentante ? row.nomeFantasiaRepresentante : ''));
                    },
                    createdCell: (td, cellData, rowData: ClienteInternetSearch, row, col) => {
                        if (cellData) {
                            td.title = ` ${rowData.codigoIntegracaoErpRepresentante ? rowData.codigoIntegracaoErpRepresentante + ' - ' : ''} ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, (rowData.nomeRepresentante ? rowData.nomeRepresentante : ''), (rowData.nomeFantasiaRepresentante ? rowData.nomeFantasiaRepresentante : ''))} `;
                        }
                    }
                },
                {
                    data: 'ecommerce',
                    className: 'col-ecommerce text-center',
                    render: (data: boolean, type, row, meta) => data ? '<i class="fas fa-check-circle" aria-hidden="true"></i>' : '',
                    createdCell: (td, cellData: boolean, rowData, row, col) => {
                        td.title = cellData ? 'Sim' : 'Não';
                    }
                },
                {
                    data: 'mercadoLivre',
                    className: 'col-mercado-livre text-center',
                    render: (data: boolean, type, row, meta) => data ? '<i class="fas fa-check-circle" aria-hidden="true"></i>' : '',
                    createdCell: (td, cellData: boolean, rowData, row, col) => {
                        td.title = cellData ? 'Sim' : 'Não';
                    }
                },
                {
                    data: 'marketplace',
                    className: 'col-marketplace text-center',
                    render: (data: boolean, type, row, meta) => data ? '<i class="fas fa-check-circle" aria-hidden="true"></i>' : '',
                    createdCell: (td, cellData: boolean, rowData, row, col) => {
                        td.title = cellData ? 'Sim' : 'Não';
                    }
                },
                {
                    data: 'eCommerces',
                    className: 'col-urls',
                    render: (data, type, row: ClienteInternetSearch, meta) => this.createEcommercesLinks(data)
                },
            ],
            ajax: (data, callback, settings) => {
                this.clienteInternetHttpService.search(this.filter, data.length, data.start)
                    .subscribe(
                        entities => {
                            callback({recordsTotal: this.total.quantidadeClientes, recordsFiltered: this.total.quantidadeClientes, data: entities});
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, 'Erro ao pesquisar as informações de internet dos clientes', error);
                            callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                        }
                    );
            }
        }).then(dataTable => {
            this.dataTable = dataTable
        })
        .catch(() => {});
    }

    /** Cria os links dos e-commerces */
    private createEcommercesLinks(ecommercesStr: string): string {
        if (!ecommercesStr) {
            return null;
        }

        // Primeiro criamos um array dos e-commerces através da string onde os e-commerces estão separados por ;
        const ecommerces = ecommercesStr.split(';');
        if (!ecommerces)  {
            return null;
        }

        // Para cada e-commerce, criamos um link
        let links =  '';
        for (let i = 0; i < ecommerces.length; i++) {
            if (links !== '') {
                links += '; ';
            }

            // Obtendo o e-commerce no array
            const ecommerce = ecommerces[i];

            // Os dados do e-commerce estão separados por | (pipe)
            const ecommerceData = ecommerce.split('|');
            const ecommerceNome = ecommerceData[0]; // Nome
            const ecommerceUrl = ecommerceData[1]; // URL

            // Adicionando o link
            links += `<a href="${ajustarUrl(ecommerceUrl)}" target="_blank" title="Abrir link">${ecommerceNome ? ecommerceNome + ' - ' : '' } ${ecommerceUrl}</a>`
        }
        return links;
    }

    /** Abre o modal para editar os dados de internet do cliente  */
    openFormModal(entity: ClienteInternetSearch) {
        if (!entity) {
            return;
        }

        this.formModal.open(entity.id);
    }

    /** Após atualizar um cliente */
    onAfterUpdate() {
        // Atualizando o total
        this.getTotal()
            .then(() => {
                // Atualizando a consulta
                this.dataTable.draw(false);
            })
            .catch(() => {});

    }
}
